export const ui = {
  it: {
    nav: {
      chi: "Chi Siamo",
      manifesto: "Manifesto",
      chiSub: "Advisor indipendente, cabina di regia",
      manifestoSub: "I principi del nostro modo di lavorare",
      insights: "Insights",
      ossTitle: "Osservatorio Energia",
      ossSub: "Prezzi PUN e PSV in Italia",
      datiSub: "Dal dato operativo al dossier di filiera",
      metodo: "Metodo",
      servizi: "Soluzioni",
      reporting: "Dati",
      target: "Clienti",
      contatti: "Contatti",
      cta: "Richiedi un'analisi",
    },
    labels: {
      chiSiamo: "Chi è Ethic",
      manifesto: "Il Manifesto",
      metodo: "Il Metodo",
      servizi: "Soluzioni",
      reporting: "Dati & Tracciabilità",
      target: "A chi ci rivolgiamo",
      osservatorio: "Osservatorio",
      partner: "Ecosistema di partner · una sola regia",
      contatti: "Parliamone",
    },
    osservatorio: {
      label: "Osservatorio",
      heading: "Osservatorio Energia",
      sub: "Segui l’andamento dei prezzi dell’energia elettrica e del gas in Italia.",
      punTitle: "PUN Energia",
      punSub: "Prezzo Unico Nazionale",
      psvTitle: "PSV Gas",
      psvSub: "Indice gas Italia",
      psvInfo: "Il valore mostrato utilizza l’indice GME di riferimento del mercato italiano del gas al PSV.",
      vediPun: "Vedi andamento PUN",
      vediPsv: "Vedi andamento PSV",
      fonte: "Fonte: GME – Gestore dei Mercati Energetici. Dati a scopo informativo.",
      ultimoAgg: "Ultimo aggiornamento",
      valoreAttuale: "Valore attuale",
      mediaPeriodo: "Media periodo",
      minimo: "Minimo",
      massimo: "Massimo",
      variazione: "Variazione periodo",
      giorni30: "30 giorni",
      mesi3: "3 mesi",
      mesi6: "6 mesi",
      mesi12: "12 mesi",
    },
    chiSiamo: {
      heading: "Advisor indipendente, cabina di regia.",
      p1: "Ethic Energy non vende un singolo prodotto: costruisce la soluzione più adatta al cliente usando il proprio ecosistema di partner. Analizza, confronta, struttura, attiva i partner giusti e governa il percorso nel tempo.",
      p2: "Lavoriamo come advisor e cabina di regia: indipendenti dai singoli venditori, allineati agli obiettivi del cliente, dalla diagnosi alla gestione operativa.",
      badge: "Advisor & Cabina di Regia",
      bullets: [
        "Consulenza energia: analisi consumi, verifica prezzi, check contrattuale e finanziario",
        "Energia green evoluta: GO, RECs, LEED, PPA e tracciabilità",
        "Impianti e tecnologie: fotovoltaico, colonnine, pompe di calore, batterie",
        "Risk e operazioni speciali: bonifiche e coperture assicurative",
      ],
      nonSiamo: [
        "Non siamo un comparatore: non ordiniamo offerte solo per prezzo.",
        "Non siamo un singolo fornitore: lavoriamo con più operatori e tecnologie.",
        "Non siamo competitor dell'Energy Manager: lavoriamo al suo fianco.",
      ],
      finale: "Siamo l'Energy Advisor operativo del cliente.",
    },
    manifesto: {
      heading: "L'energia non è un prodotto da comprare. È un sistema da governare.",
      sub: "Prezzo, consumi, impianti, investimenti, incentivi, rischio ed ESG devono essere letti insieme. Ethic parte dal profilo reale del cliente e costruisce una strategia integrata, selezionando per ogni esigenza la soluzione e il partner più adatti.",
      intro: "Ogni azienda ha consumi, impianti, obiettivi, capacità finanziaria, profilo di rischio e priorità differenti. Per questo una buona strategia energetica non nasce da un catalogo di prodotti. Nasce dalla comprensione del cliente.\n\nEthic mette insieme mercato, energia, tecnologia e finanza per decidere cosa acquistare, come consumare meglio, quando investire, quali incentivi utilizzare, quali rischi presidiare e quali partner coinvolgere.",
      old: "Vecchio approccio",
      new: "Manifesto Ethic",
    },
    metodo: {
      heading: "Il Metodo Ethic in 5 step",
      claim: "Partiamo dai dati. Costruiamo la strategia. Coordiniamo l'execution. Continuiamo a ottimizzare.",
      sub: "Ethic parte dall'energia e dalla fotografia reale del cliente per integrare approvvigionamento, consumi, impianti, investimenti, incentivi, rischio ed ESG in un unico percorso.",
    },
    servizi: {
      heading: "Tre aree, un unico obiettivo.",
      sub: "Comprare meglio è solo metà del lavoro: fornitura, efficienza e servizi specialistici coordinati dalla stessa regia. Le necessità cambiano nel tempo, Ethic Energy continua a gestirle.",
    },
    partners: {
      heading: "Un unico advisor. Un ecosistema di specialisti.",
      sub: "Operatori energetici, società di efficientamento, tecnologie e servizi assicurativi, coinvolti in funzione del progetto e del profilo del cliente. La relazione, l'analisi e il coordinamento restano in capo a Ethic.",
    },
    energyManager: {
      label: "Complementari, mai in competizione",
      heading: "Al fianco dell'Energy Manager, non al suo posto.",
      text: "Quando in azienda esistono già un Energy Manager, un team procurement, facility o tecnico, Ethic lavora in armonia con queste funzioni: porta profondità di mercato, accesso a più controparti, strumenti specialistici ed execution. Le decisioni e la governance restano al cliente.",
    },
    esg: {
      heading: "Il dato diventa evidenza.",
      sub: "Un'anteprima della reportistica Ethic: dal dato operativo al dossier di fornitura, leggibile da CFO, energy manager e marketing.",
      demo: "Dati dimostrativi — simulazione su profilo di consumo 2,0 GWh",
      slider: "Quota rinnovabile con matching orario",
      gauge: "Matching score",
      location: "Location-based",
      market: "Market-based",
      impact: "Impatto sourcing",
      download: "Scarica executive summary",
      monthly: "Matching mensile (%)",
    },
    contact: {
      heading: "Richiedi un'analisi del tuo profilo energetico.",
      sub: "Raccontaci il tuo profilo: ti ricontattiamo entro 24 ore lavorative con i prossimi passi.",
      nome: "Nome e cognome",
      azienda: "Azienda",
      email: "Email",
      ruolo: "Ruolo",
      telefono: "Telefono",
      consumo: "Consumo annuo stimato",
      tipologia: "Tipologia cliente",
      scadenza: "Scadenza contratto (se nota)",
      bolletta: "Invia una bolletta (PDF, max 8MB — opzionale)",
      messaggio: "Messaggio",
      submit: "Invia richiesta",
      sending: "Invio in corso…",
      success: "Richiesta inviata. Ti ricontattiamo entro 24 ore lavorative.",
      error: "Errore nell'invio. Riprova tra poco.",
      privacy: "Inviando accetti la nostra privacy policy. I tuoi dati non saranno ceduti a terzi.",
      consumoOptions: ["< 0,5 GWh", "0,5 – 2 GWh", "2 – 10 GWh", "> 10 GWh"],
      tipologiaOptions: ["SGR e Fondi", "Industrie", "Condomìni", "PMI", "Hospitality & Retail", "Altro"],
    },
    footer: {
      sections: "Sezioni",
      legal: "Legale",
      privacy: "Privacy Policy",
      cookie: "Cookie Policy",
      rights: "Tutti i diritti riservati.",
    },
  },
  en: {
    nav: {
      chi: "About",
      manifesto: "Manifesto",
      chiSub: "Independent advisor, control tower",
      manifestoSub: "The principles behind how we work",
      insights: "Insights",
      ossTitle: "Energy Watch",
      ossSub: "PUN & PSV prices in Italy",
      datiSub: "From operational data to the supply dossier",
      metodo: "Method",
      servizi: "Solutions",
      reporting: "Data",
      target: "Clients",
      contatti: "Contact",
      cta: "Request an Analysis",
    },
    labels: {
      chiSiamo: "Who is Ethic",
      manifesto: "The Manifesto",
      metodo: "The Method",
      servizi: "Solutions",
      reporting: "Data & Traceability",
      target: "Who we serve",
      osservatorio: "Energy Watch",
      partner: "Partner ecosystem · one control tower",
      contatti: "Let's talk",
    },
    osservatorio: {
      label: "Energy Watch",
      heading: "Energy Watch",
      sub: "Follow electricity and gas price trends in Italy.",
      punTitle: "PUN Power",
      punSub: "Italian National Single Price",
      psvTitle: "PSV Gas",
      psvSub: "Italian gas index",
      psvInfo: "The value shown uses the GME reference index for the Italian gas market at PSV.",
      vediPun: "See PUN trend",
      vediPsv: "See PSV trend",
      fonte: "Source: GME – Gestore dei Mercati Energetici. Data for information purposes only.",
      ultimoAgg: "Last update",
      valoreAttuale: "Current value",
      mediaPeriodo: "Period average",
      minimo: "Minimum",
      massimo: "Maximum",
      variazione: "Period change",
      giorni30: "30 days",
      mesi3: "3 months",
      mesi6: "6 months",
      mesi12: "12 months",
    },
    chiSiamo: {
      heading: "Independent advisor, control tower.",
      p1: "Ethic Energy doesn't sell a single product: it builds the right solution for each client through its partner ecosystem. It analyses, compares, structures, activates the right partners and governs the journey over time.",
      p2: "We work as advisors and control tower: independent from individual sellers, aligned with client goals, from diagnosis to operational management.",
      badge: "Advisor & Control Tower",
      bullets: [
        "Energy advisory: consumption analysis, price review, contractual & financial checks",
        "Advanced green energy: GOs, RECs, LEED, PPAs and traceability",
        "Plants & technologies: PV, EV chargers, heat pumps, batteries",
        "Risk & special operations: remediation and insurance cover",
      ],
      nonSiamo: [
        "We are not a comparison site: we don't just rank offers by price.",
        "We are not a single supplier: we work with multiple operators and technologies.",
        "We don't compete with your Energy Manager: we work alongside them.",
      ],
      finale: "We are the client's operational Energy Advisor.",
    },
    manifesto: {
      heading: "Energy is not a product to buy. It is a system to govern.",
      sub: "Price, consumption, plants, investments, incentives, risk and ESG must be read together. Ethic starts from the client's real profile and builds an integrated strategy, selecting the most suitable solution and partner for each need.",
      intro: "Every company has different consumption, plants, goals, financial capacity, risk profile and priorities. That is why a good energy strategy is not born from a product catalogue. It is born from understanding the client.\n\nEthic brings together market, energy, technology and finance to decide what to buy, how to consume better, when to invest, which incentives to use, which risks to cover and which partners to involve.",
      old: "Old way",
      new: "Ethic Manifesto",
    },
    metodo: {
      heading: "The Ethic Method in 5 steps",
      claim: "We start from data. We build the strategy. We coordinate execution. We keep optimizing.",
      sub: "Ethic starts from energy and the client's real profile to integrate procurement, consumption, plants, investments, incentives, risk and ESG into a single path.",
    },
    servizi: {
      heading: "Three areas, one goal.",
      sub: "Buying better is only half the job: supply, efficiency and specialist services coordinated by one control tower. Needs change over time — Ethic Energy keeps managing them.",
    },
    partners: {
      heading: "One advisor. An ecosystem of specialists.",
      sub: "Energy operators, efficiency companies, technologies and insurance services, engaged according to the project and the client profile. Relationship, analysis and coordination remain with Ethic.",
    },
    energyManager: {
      label: "Complementary, never competing",
      heading: "Alongside the Energy Manager, not in their place.",
      text: "When a company already has an Energy Manager, procurement, facility or technical team, Ethic works in harmony with these functions: bringing market depth, access to multiple counterparties, specialist tools and execution. Decisions and governance stay with the client.",
    },
    esg: {
      heading: "Data becomes evidence.",
      sub: "A preview of Ethic's reporting: from operational data to the supply dossier, readable by CFOs, energy managers and marketing.",
      demo: "Demo data — simulation on a 2.0 GWh consumption profile",
      slider: "Renewable share with hourly matching",
      gauge: "Matching score",
      location: "Location-based",
      market: "Market-based",
      impact: "Sourcing impact",
      download: "Download executive summary",
      monthly: "Monthly matching (%)",
    },
    contact: {
      heading: "Request an analysis of your energy profile.",
      sub: "Tell us about your profile: we'll get back within one business day with next steps.",
      nome: "Full name",
      azienda: "Company",
      email: "Email",
      ruolo: "Role",
      telefono: "Phone",
      consumo: "Estimated annual consumption",
      tipologia: "Client type",
      scadenza: "Contract expiry (if known)",
      bolletta: "Send a bill (PDF, max 8MB — optional)",
      messaggio: "Message",
      submit: "Send request",
      sending: "Sending…",
      success: "Request sent. We'll get back within one business day.",
      error: "Send failed. Please try again shortly.",
      privacy: "By submitting you accept our privacy policy. Your data will never be shared with third parties.",
      consumoOptions: ["< 0.5 GWh", "0.5 – 2 GWh", "2 – 10 GWh", "> 10 GWh"],
      tipologiaOptions: ["SGR & Funds", "Industries", "Condominiums", "SMEs", "Hospitality & Retail", "Other"],
    },
    footer: {
      sections: "Sections",
      legal: "Legal",
      privacy: "Privacy Policy",
      cookie: "Cookie Policy",
      rights: "All rights reserved.",
    },
  },
};
